function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import classnames from 'classnames';
import { IconInfo } from "../Icons";
import injectStyles from "../jss";
import styles from "./Tooltip.jss";
var TOOLTIP_MARGIN = 10;
export var Tooltip = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Tooltip, _React$PureComponent);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      hovered: false,
      left: '-9999px',
      top: '-9999px'
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tooltipBody", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tooltipBlock", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPosition", function () {
      if (_this.tooltipBody && _this.tooltipBlock && _this.state.hovered) {
        var tooltipBoundaries = _this.tooltipBody.getBoundingClientRect(); // $FlowFixMe


        var _this$tooltipBlock = _this.tooltipBlock,
            tooltipBlockWidth = _this$tooltipBlock.offsetWidth,
            tooltipBlockHeight = _this$tooltipBlock.offsetHeight;
        var x = tooltipBoundaries.left,
            y = tooltipBoundaries.top,
            tooltipElementWidth = tooltipBoundaries.width,
            tooltipElementHeight = tooltipBoundaries.height;
        var position = 'CenterBottom';
        var topSpace = y;
        var rightSpace = window.innerWidth - x;
        var bottomSpace = window.innerHeight - y;
        var leftSpace = x;

        if (topSpace > tooltipBlockHeight + TOOLTIP_MARGIN && leftSpace > tooltipBlockWidth / 2 && rightSpace > tooltipBlockWidth / 2) {
          position = 'CenterTop';
        } else if (bottomSpace > tooltipBlockHeight + tooltipElementHeight + TOOLTIP_MARGIN && leftSpace > tooltipBlockWidth / 2 && rightSpace > tooltipBlockWidth / 2) {
          position = 'CenterBottom';
        } else if (rightSpace > tooltipBlockWidth + tooltipElementWidth / 2 + TOOLTIP_MARGIN) {
          position = 'Right';

          if (bottomSpace < tooltipBlockHeight / 2 + tooltipElementHeight / 2) {
            position = 'RightTop';
          } else if (topSpace + tooltipElementHeight / 2 < tooltipBlockHeight / 2) {
            position = 'RightBottom';
          }
        } else if (leftSpace > tooltipBlockWidth + tooltipElementWidth / 2 + TOOLTIP_MARGIN) {
          position = 'Left';

          if (bottomSpace < tooltipBlockHeight / 2 + tooltipElementHeight / 2) {
            position = 'LeftTop';
          } else if (topSpace + tooltipElementHeight / 2 < tooltipBlockHeight / 2) {
            position = 'LeftBottom';
          }
        }

        var top;
        var left;

        if (position === 'CenterTop') {
          top = "".concat(topSpace - tooltipBlockHeight - TOOLTIP_MARGIN, "px");
          left = "".concat(leftSpace - tooltipBlockWidth / 2 + tooltipElementWidth / 2, "px");
        } else if (position === 'CenterBottom') {
          top = "".concat(topSpace + tooltipElementHeight + TOOLTIP_MARGIN, "px");
          left = "".concat(leftSpace - tooltipBlockWidth / 2 + tooltipElementWidth / 2, "px");
        } else if (position === 'Right') {
          top = "".concat(topSpace - tooltipBlockHeight / 2 + tooltipElementHeight / 2, "px");
          left = "".concat(leftSpace + tooltipElementWidth + TOOLTIP_MARGIN, "px");
        } else if (position === 'RightTop') {
          top = "".concat(topSpace - tooltipBlockHeight - TOOLTIP_MARGIN, "px");
          left = "".concat(leftSpace, "px");
        } else if (position === 'RightBottom') {
          top = "".concat(topSpace + tooltipElementHeight + TOOLTIP_MARGIN, "px");
          left = "".concat(leftSpace, "px");
        } else if (position === 'Left') {
          top = "".concat(topSpace - tooltipBlockHeight / 2 + tooltipElementHeight / 2, "px");
          left = "".concat(leftSpace - tooltipBlockWidth - TOOLTIP_MARGIN, "px");
        } else if (position === 'LeftTop') {
          top = "".concat(topSpace - tooltipBlockHeight - TOOLTIP_MARGIN, "px");
          left = "".concat(leftSpace - tooltipBlockWidth + tooltipElementWidth, "px");
        } else if (position === 'LeftBottom') {
          top = "".concat(topSpace + tooltipElementHeight + TOOLTIP_MARGIN, "px");
          left = "".concat(leftSpace - tooltipBlockWidth + tooltipElementWidth, "px");
        }

        _this.setState({
          position: position,
          top: top,
          left: left
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showTooltip", function () {
      _this.setState({
        hovered: true
      }, function () {
        _this.getPosition();
      });

      document.addEventListener('touchstart', _this.hideTooltip);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hideTooltip", function () {
      _this.setState({
        hovered: false
      });

      document.removeEventListener('touchstart', _this.hideTooltip);
    });

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('scroll', this.getPosition);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.getPosition);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          color = _this$props.color,
          colors = _this$props.globals.colors,
          hoverColor = _this$props.hoverColor,
          size = _this$props.size,
          tooltip = _this$props.tooltip,
          tooltipElement = _this$props.tooltipElement;
      var _this$state = this.state,
          hovered = _this$state.hovered,
          position = _this$state.position,
          top = _this$state.top,
          left = _this$state.left;
      var inactiveIconColor = color || colors.gray;
      var hoveredColor = hoverColor || colors.primary;
      var iconColor = hovered ? hoveredColor : inactiveIconColor; // $FlowFixMe

      var iconSize = "".concat(size, "px");
      var tooltipPosition = classes["tooltip".concat(position)];

      if (!tooltip) {
        return null;
      }

      return React.createElement("div", {
        className: classnames(classes.wrapper, className)
      }, React.createElement("div", {
        style: {
          top: top,
          left: left
        },
        className: classnames(classes.tooltip, tooltipPosition, hovered && classes.hovered),
        ref: function ref(e) {
          _this2.tooltipBlock = e;
        }
      }, React.createElement("div", {
        className: classnames('tooltip-content', classes.tooltipContent)
      }, tooltip)), React.createElement("div", {
        className: classes.elementWrapper,
        onMouseEnter: this.showTooltip,
        onMouseLeave: this.hideTooltip,
        onTouchStart: this.showTooltip,
        ref: function ref(e) {
          _this2.tooltipBody = e;
        }
      }, tooltipElement || React.createElement(IconInfo, {
        style: {
          width: iconSize,
          height: iconSize
        },
        fill: iconColor,
        className: classes.icon
      })));
    }
  }]);

  return Tooltip;
}(React.PureComponent);

_defineProperty(Tooltip, "styleRoot", 'Tooltip');

_defineProperty(Tooltip, "defaultProps", {
  size: 26
});

export default injectStyles(styles)(Tooltip);